import { Checkbox, TableCell } from '@mui/material';

// ----------------------------------------------------------------------

type Props = {
  selectRowPremission?: boolean;
  row: any;
  table: any;
  isCampaignTamplate: boolean;
  interactionLocked?: boolean;
};

// ----------------------------------------------------------------------

export function RowCellCheckbox({ selectRowPremission, row, table, isCampaignTamplate, interactionLocked }: Props) {
  if (!selectRowPremission) {
    return null;
  }

  return (
    <TableCell padding="checkbox">
      <Checkbox
        checked={'id' in row ? table.selected.includes(row.id) : false}
        disabled={interactionLocked}
        onClick={() => {
          if (interactionLocked) return;
          if ('id' in row) {
            table.onSelectRow(row.id, !isCampaignTamplate);
          }
        }}
        inputProps={{
          id: 'id' in row ? `${row.id}-checkbox` : undefined,
          'aria-label': 'id' in row ? `${row.id} checkbox` : undefined,
        }}
        sx={{
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'scale(1.1)',
          },
        }}
      />
    </TableCell>
  );
}
